import React, { useState } from 'react';
import { Modal, Button } from 'antd';
export default function ExpiredModal(props) {
    var _a = useState(props.isVisible), visible = _a[0], setVisible = _a[1];
    return (React.createElement(Modal, { title: "\u514D\u8D39\u8BD5\u7528\u7ED3\u675F", okText: "\u597D\u7684", visible: visible, onCancel: function () {
            setVisible(false);
        }, footer: [
            React.createElement(Button, { key: "back", onClick: function () {
                    setVisible(false);
                } }, "\u597D\u7684"),
        ], width: 360, style: { top: '30%' } },
        React.createElement("p", null, "\u60A8\u7684\u514D\u8D39\u8BD5\u7528\u65F6\u957F\u5DF2\u7528\u5C3D\uFF0C\u5982\u60A8\u60F3\u7EE7\u7EED\u4F7F\u7528\uFF0C\u6216\u6709\u5176\u4ED6\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB400-615-1212\u8FDB\u884C\u54A8\u8BE2\u3002")));
}
//# sourceMappingURL=ExpiredModal.js.map